<template>
<div class='testPage'>
  <Row>
    <Col span="24"><p class="title">考试说明</p></Col>
    <Col span="24">
      <div style="height:70vh;overflow:auto">
        <div v-html="content" v-if="content"></div>
        <p v-else>暂无说明</p>
      </div></Col>
    <Col span="24" v-if="testId">
      <p class="agree">
        <Checkbox v-model="check">
          我只阅读并确认上述考试说明内容，知悉由此产生的相关后果
        </Checkbox>
      </p>
      <Divider/>
    </Col>
    <Col span="24" style="text-align:center;padding:.5vw 0;" v-if="check">
      <Button type="primary" @click="goAnswer">开始考试</Button>
    </Col>
  </Row>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    content:'',
    check:false,
    testId:'',//套题id
    count:null,//答题时间
  };
},
activated(){
  this.getContent()
},
//方法集合
methods: {
  goAnswer(){
    this.$axios
    .get("/safe-train/exam/startExam?id=" + this.testId)
    .then((res) => {
      if (res.code == 1) {
        this.$router.push({name:'TestAnswerPage',query:{testId:this.testId,count:this.count}})
      } else {
        this.$Message.error(res.msg);
      }
    });
  },
  getContent(){
  let reg = new RegExp('&amp;nbsp;', 'g');// g代表全部
   this.$Spin.show({
        render: (h) => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 20,
              },
            }),
            h("div", "请耐心等待"),
          ]);
        },
      });
    this.$axios
    .get("/safe-train/exam/getExamList")
    .then((res) => {
      if (res.code == 1) {
        this.$Spin.hide();
        if(!res.data.id){
          this.$Message.warning('暂无试题')
          return
        }
        this.content = res.data.content.replace(reg, '\u3000');
        this.testId = res.data.id;
        this.count = res.data.quizTime
      } else {
        this.$Message.error(res.msg);
      }
    });
  }
},
}
</script>
<style lang='less' scoped>
.testPage{
  height: 100%;
  overflow: auto;
  padding: 1vw;

  .title{
    text-align: center;
    font-size: 2vw;
    padding: .5vw 0;
    color: #000;
    font-weight: bold;
  }
  .agree{
    color:teal;
  }
}
</style>